module.exports = __webpack_public_path__ + "static/img/Rabbit.a320c76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/cz_animal/Rabbit.svg
// module id = 1365
// module chunks = 0